import { ProductApi } from "@/zh-website/src/views/Enterprise/api/ProductApi";
import { BaseAbstractService } from "@common/service/base-service/global";
import RequestService from "@common/service/base-service/request/ICT2BRequest";

export class ProductService extends BaseAbstractService {
  static getTrainingNewsList(query) {
    //query {typeList:1 2 3} 类型：1：政企 2：高校 3：合作伙伴
    return ProductApi.getTrainingNewsList(this.request, query);
  }
  static getClassification(query) {
    //query {typeList:1 2 3} 类型：1：政企 2：高校 3：合作伙伴
    return ProductApi.getClassification(this.request, query);
  }
  static getSuccessCase(query) {
    //query {typeList:1 2 3} 类型：1：政企 2：高校 3：合作伙伴
    return ProductApi.getSuccessCase(this.request, query);
  }
  static getSolutionList(query) {
    //query {typeList:1 2 3} 类型：1：政企 2：高校 3：合作伙伴
    return ProductApi.getSolutionList(this.request, query);
  }
}
ProductService.setRequest(RequestService);
